import React, { useState, useEffect } from 'react';
import { questionService } from '../../firebase/questionService';
import type { GameSettings, Category } from '../../types/game';

const AdminSettings: React.FC = () => {
  const [settings, setSettings] = useState<GameSettings>({
    categoriesPerRound: 5,
    questionsPerCategory: 5,
    useRandomFinalJeopardy: true,
  });
  const [categories, setCategories] = useState<Category[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    const cats = await questionService.getCategories();
    setCategories(cats.filter(c => c.isActive !== false));
  };

  const handleSave = async () => {
    setSaving(true);
    // TODO: Save settings to Firebase
    setSaving(false);
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-brand-yellow mb-6">Game Settings</h2>
      <div className="space-y-6">
        <div>
          <label className="block text-brand-yellow font-bold mb-2">Categories per Round</label>
          <input
            type="number"
            min="3"
            max="6"
            value={settings.categoriesPerRound}
            onChange={(e) => setSettings(s => ({ ...s, categoriesPerRound: parseInt(e.target.value) }))}
            className="w-full bg-[#333] text-white rounded-lg px-4 py-3 border border-brand-yellow/30 focus:border-brand-yellow focus:outline-none"
          />
        </div>
        <div>
          <label className="block text-brand-yellow font-bold mb-2">Questions per Category</label>
          <input
            type="number"
            min="3"
            max="6"
            value={settings.questionsPerCategory}
            onChange={(e) => setSettings(s => ({ ...s, questionsPerCategory: parseInt(e.target.value) }))}
            className="w-full bg-[#333] text-white rounded-lg px-4 py-3 border border-brand-yellow/30 focus:border-brand-yellow focus:outline-none"
          />
        </div>
        <div>
          <label className="flex items-center gap-2 text-brand-yellow font-bold">
            <input
              type="checkbox"
              checked={settings.useRandomFinalJeopardy}
              onChange={(e) => setSettings(s => ({ ...s, useRandomFinalJeopardy: e.target.checked }))}
              className="w-4 h-4 rounded border-brand-yellow/30 focus:ring-brand-yellow"
            />
            Use Random Final Jeopardy
          </label>
        </div>
        {!settings.useRandomFinalJeopardy && (
          <div>
            <label className="block text-brand-yellow font-bold mb-2">Final Jeopardy Category</label>
            <select
              value={settings.finalJeopardyCategory || ''}
              onChange={(e) => setSettings(s => ({ ...s, finalJeopardyCategory: e.target.value }))}
              className="w-full bg-[#333] text-white rounded-lg px-4 py-3 border border-brand-yellow/30 focus:border-brand-yellow focus:outline-none"
            >
              <option value="">Select a category</option>
              {categories.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </select>
          </div>
        )}
        <div className="flex justify-end">
          <button
            onClick={handleSave}
            disabled={saving}
            className="bg-brand-yellow text-black font-bold px-6 py-3 rounded-lg hover:bg-[#fccd6c]/90 transition-colors disabled:opacity-50"
          >
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings; 